import React, {useEffect} from 'react';
import {VStack} from "native-base";
import AppText from "../../../../common/AppText";
import FormInput from "../../../../common/FormInput";
import {t} from "i18next";
import {fetchApi} from "../../../../../services/HTTP";

const SitePixelSettings = (props) => {
    const { values, errors, touched, setFieldValue } = props;

    useEffect(() => {
        getSitePixels()
    }, []);

    const getSitePixels = async () => {
        try {
            const res = await fetchApi('boxes/getPixels', 'GET', null, false, true)
            if (res?.facebook) {
                setFieldValue('facebook', res?.facebook)
            }
            if (res?.tiktok) {
                setFieldValue('tiktok', res?.tiktok)
            }
        } catch(error) {
            console.log('getSitePixels error', error)
        }
    }


    return (
        <VStack space={'1rem'}>
            <AppText>{t('site-pixel-subheader')}</AppText>
            <VStack space={'0.2rem'}>
                <FormInput
                    label={t('facebook-pixel')}
                    placeholder={t('facebook-pixel-placeholder')}
                    onChangeCallback={(val) => setFieldValue('facebook', val)}
                    value={values.facebook}
                    error={touched.facebook && errors.facebook}
                    width={'100%'}
                />
                <FormInput
                    label={t('tiktok-pixel')}
                    placeholder={t('tiktok-pixel-placeholder')}
                    onChangeCallback={(val) => setFieldValue('tiktok', val)}
                    value={values.tiktok}
                    error={touched.tiktok && errors.tiktok}
                    width={'100%'}
                />
            </VStack>
        </VStack>
    );
};

export default SitePixelSettings;